import { render, staticRenderFns } from "./bg-image.vue?vue&type=template&id=2b066fda"
import script from "./bg-image.vue?vue&type=script&lang=js"
export * from "./bg-image.vue?vue&type=script&lang=js"
import style0 from "./bg-image.vue?vue&type=style&index=0&id=2b066fda&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/php7/hartovasilion.gr/public/site/hartovasilion/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b066fda')) {
      api.createRecord('2b066fda', component.options)
    } else {
      api.reload('2b066fda', component.options)
    }
    module.hot.accept("./bg-image.vue?vue&type=template&id=2b066fda", function () {
      api.rerender('2b066fda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/bg-image/bg-image.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/js/components/bg-image/bg-image.vue
// module id = ./src/js/components/bg-image/bg-image.vue
// module chunks = 4 5